export const APP_NAME = "SparkGPT";